import React, { useState, useEffect, useCallback } from 'react';
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import ReactModal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import parse from 'html-react-parser';
import BackButton from "../../../images/button_back.gif";
import HomeButton from "../../../images/button_home.gif";
import Image from '../Image/Image';
import ButtonNewFolder from "../../../images/button_new_folder.gif";
import ButtonUpload from '../../../images/button_upload.gif';
import User from '../../../images/users.gif';
import BulkUploadPopup from "../Modal/bulkUploadPopup";
import BulkDownload from "../../../images/download.gif";
import BulkDownloadPopup from "../Modal/bulkDownloadPopup";
import Admin from "../../../images/admin.gif";
import Modal from '../../common/Modal';
import { updateMediaServerUrlsToempty, getSubDirectories, noDirOrUserFound, deleteFileStateInfo } from '../../Dashboard/actions';
import { updateGenricSuccessMessageToEmpty, getUserList } from '../../User/actions';
import TopNav from './TopNav';
import NewFolder from '../Modal/NewFolder';
import MediaSearch from './SearchBox';
import ButtonBulkRename from '../../../images/bulkrename.gif';
import BulkRenamePopup from "../Modal/bulkRenamePopup";
import {
  appendAppQuery,
  buildMediaPathFromSuffix,
} from '../../utils/pathUtils';

const Banner = (props) => {
  const [bannerMessage, setBannerMessage] = useState("");
   const [phpbannerMessage, setphpBannerMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [mediaServerUrl, setMediaServerUrl] = useState('');
  const [mediaServerFileName, setMediaServerFileName] = useState('');
  const [curriculumUrl, setCurriculumURL] = useState('');
  const [liveUrlSet, setLiveUrlSet] = useState(0);
  const [genericSuccessMessages, setGenericSuccessMessages] = useState('');
  const controller = new AbortController();
  const mediaServerURLs = useSelector(state => { return state.directoriesReducer.mediaServerURLs });
  const successMessage = useSelector(state => { return state.UserReducer.userSuccessMessage });
  const deletedFilesInfo = useSelector(state => { return state.directoriesReducer.fileDeleteInfo });
  const [bulkdownload, setbulkdownload] = useState(false);
  const [bulkrename, setbulkrename] = useState(false);

  useEffect(() => {
    setMediaServerUrl(mediaServerURLs?.liveurl);
    setCurriculumURL(mediaServerURLs?.curriculum_liveurl);
    setLiveUrlSet(mediaServerURLs?.push_live_ok);
    setMediaServerFileName(mediaServerURLs?.file_name)
  }, [mediaServerURLs]);

  useEffect(() => {
    setGenericSuccessMessages(successMessage);
    if (successMessage.status_code === 200 && (location.pathname).includes('/user/list')) {
      dispatch(getUserList())
    }
    else if (successMessage.status_code === 200 && (location.pathname).includes('/mdc/auth/media')) {
      dispatch(getSubDirectories({ dir: props.currentPath }));
    }
  }, [successMessage, location])

  const navigateBack = (e) => {
    let navigateToPreviousPath = (props.currentPath).split('/');
    navigateToPreviousPath.pop();
    navigateToPreviousPath = navigateToPreviousPath.filter(path => path);
    navigateToPreviousPath = `/${navigateToPreviousPath.join('/')}`;
    if (navigateToPreviousPath !== '/' && navigateToPreviousPath !== '/user') {
      navigate(buildMediaPathFromSuffix(navigateToPreviousPath));
    } else {
      navigate('/mdc/auth/media');
    }
  }

  const navigateToHome = (e) => {
    navigate('/mdc/auth/media');
  }

  const navigateToUsers = (e) => {
    navigate('/user/list');
  }

  let [modal, setModal] = useState(false);
  const [bulkModal, setBulkModal] = useState(false);
  const [newFolderName, setNewFolderName] = useState(false);

  const handleModalPopupStateChange = useCallback((data) => {
    setModal(!data);
  }, [])

  const handleModalBulkUploadPopupStateChange = useCallback((data, e) => {
    if (
      e?.target?.tagName &&
      (e.target.tagName === 'SPAN' || e.target.tagName === 'BUTTON') &&
      typeof e.target.outerHTML === 'string' &&
      e.target.outerHTML.includes('close')
    ) {
      setBulkModal(!data);
    }
    e.preventDefault();
  }, [])


  const toggleRenamePopup = useCallback((info) => {
    //dispatch(getSubDirectories({ dir: props.currentPath }))
    setbulkrename(!bulkrename);
  }, [location]);

  const selectModal = (info) => {
    navigate(appendAppQuery(location.pathname, 'upload'));
    setModal(!modal);
  }

  const NavigateToPath = (e) => {
    navigate(buildMediaPathFromSuffix(e.target.value));
  }

  const navigateToAdmin = (e) => {
    navigate('/admin');
  }

  const styles = {
    directoriesButton: {
      borderStyle: "none",
      color: "#006",
      cursor: "pointer",
      textDecoration: "underline",
      marginRight: "-6px",
      paddingLeft: "1px",
      fontWeight: "bold",
      fontSize: "12px"
    }
  }
  const customStyles = {
    content: {
      height: '246px',
      top: '-25%',
    },
  };
  let pathPieces = props.currentPath.split('/').filter(dir => dir);
  let directoriesLink = [];
  let defaultPath = '';
  pathPieces.forEach(path => {
    defaultPath = defaultPath + '/' + path;
    directoriesLink.push(<strong>/<button onClick={NavigateToPath} value={defaultPath} style={styles.directoriesButton}> {decodeURIComponent(path)}</button></strong>);
  });

  // when directory path is changed clean up mediaserver urls
  useEffect(() => {
    dispatch(updateMediaServerUrlsToempty({}));
    dispatch(updateGenricSuccessMessageToEmpty({}));
    dispatch(noDirOrUserFound({}))
    dispatch(deleteFileStateInfo({}))
    if ((location.pathname).includes('/mdc/auth/media')) {
      setTimeout(() => {
        dispatch(getSubDirectories({ dir: props.currentPath }));
      }, 1000)
    }
  }, [dispatch, location])

  const toggleUploadPopup = useCallback((info) => {
    navigate(appendAppQuery(location.pathname, 'bulkupload'));
    setBulkModal(!bulkModal);
  }, [location]);

  const createNewFolder = (event) => {
    event.preventDefault();
    navigate(appendAppQuery(location.pathname, 'newfolder'));
    setNewFolderName(!newFolderName);
  }
  const handleModalBulkDownloadPopupStateChange = useCallback((data) => {
    setbulkdownload(!data);
  }, [])

  const handleModalBulkRenamePopupStateChange = useCallback((data) => {
    setbulkrename(!data);
  }, [])

  const toggleDownloadPopup = useCallback((info) => {
    //dispatch(getSubDirectories({ dir: props.currentPath }))
    setbulkdownload(!bulkdownload);
  }, [location]);

  useEffect(() => {
    if (deletedFilesInfo?.status_code === 200 || deletedFilesInfo?.status_code === 500) {
      const timeout = setTimeout(() => {
        dispatch(deleteFileStateInfo({}));
      }, 4000);

      return () => clearTimeout(timeout);
    }
  }, [deletedFilesInfo?.status_code, dispatch]);


  useEffect(() => {
    if (deletedFilesInfo?.status_code == 200 || deletedFilesInfo?.status_code == 500) {
      dispatch(getSubDirectories({ dir: props.currentPath }));
    }
  }, [deletedFilesInfo])

  const closeCreateFolderModalPopup = (popupStatus) => {
    setNewFolderName(!popupStatus);
  }
  useEffect(() => {
    setphpBannerMessage(
     <><strong>Important Update: PHP upload restrictions are now in effect.</strong>
      {' '}
      New php4 and php5 content can only be uploaded within the designated <strong>php8</strong> folder.
      ZIP uploads and unzip operations that contain restricted php4 or php5 files outside php8 will be blocked.
      Existing php4 and php5 files will be allowed to update until migration to php8 is complete.
      </>
    );
   setBannerMessage(
      <><strong className="banner-highlight">Action required - SMS Authentication on Media Server.</strong>
<br/>If you manage any HTML-based content on the Media Server, that does not use the WRAPS template to manage SMS interactions, please note this on the form <a href="https://pearsoneducationinc-my.sharepoint.com/:x:/g/personal/pradeep_devasya_pearson_com/IQAICzRQV0_7R5w9eiWiqSEVAcOfT5zsXC3QhuvLtqhoNLk?wdOrigin=TEAMS-MAGLEV.p2p_ns.rwc&wdExp=TEAMS-TREATMENT&wdhostclicktime=1766380596279&web=1" target="_blank" rel="noopener noreferrer" style={{ color: "#0000EE", textDecoration: "underline" }}>sheet</a> so that we can contact you about changes needed.        
      </>
    );
  }, []);
   
  return (
    <div>
      <TopNav title={props.title} currentPath={props.currentPath} />
      <table border="0" width="100%" cellSpacing="0" cellPadding="0">
        <tbody>
          {/* Toolbar row */}
          <tr>
            {/* Back */}
            <td style={{ padding: "10px 6px 0 0" }}>
              <Image src={BackButton} alt="Back" title="Back" width="51" height="48" onClick={navigateBack} className="folderpointer" />
            </td>

            {/* Home */}
            <td style={{ padding: "10px 6px 0 0" }}>
              <Image src={HomeButton} alt="Home" title="Home" width="51" height="48" onClick={navigateToHome} className="folderpointer" />
            </td>

            {/* New Folder */}
            {!props.disableCheckbox && (
              <td style={{ padding: "10px 6px 0 0" }}>
                <img src={ButtonNewFolder} alt="New Folder" title="New Folder" width="51" height="48" onClick={createNewFolder} className="folderpointer" />
              </td>
            )}

            {/* Upload */}
            {!props.disableCheckbox && (
              <td style={{ padding: "10px 6px 0 0" }}>
                <img src={ButtonUpload} alt="Upload" title="Upload" width="51" height="50" onClick={toggleUploadPopup} className="folderpointer" />
              </td>
            )}

            {/* Download */}
            {!props.disableCheckbox && (
              <td style={{ padding: "10px 6px 0 0" }}>
                <img src={BulkDownload} alt="Download" title="Download" width="51" height="48" onClick={toggleDownloadPopup} className="folderpointer" />
              </td>
            )}

            {/* Rename */}
            {!props.disableCheckbox && (
              <td style={{ padding: "10px 6px 0 0" }}>
                <img src={ButtonBulkRename} alt="Bulk Rename" title="BulkRename" width="51" height="48" onClick={toggleRenamePopup} className="folderpointer" />
              </td>
            )}


            {/* Admin */}
            {(localStorage.getItem("user.role") === "Super Admin" ||
              localStorage.getItem("user.role") === "Admin") && (
                <td style={{ padding: "10px 6px 0 0" }}>
                  <img src={Admin} alt="Admin" title="Admin" width="51" height="48" onClick={navigateToAdmin} className="folderpointer" />
                </td>
              )}

            {/* Users */}
            {(localStorage.getItem("user.role") === "Super Admin" ||
              localStorage.getItem("user.role") === "Admin") && (
                <td style={{ padding: "10px 6px 0 0" }}>
                  <img src={User} alt="User" title="User" width="51" height="48" onClick={navigateToUsers} className="folderpointer" />
                </td>
              )}

            {/* Spacer pushes search right */}
            <td style={{ width: "100%" }} />


            {(localStorage.getItem("user.role") === "Super Admin" ||
              localStorage.getItem("user.role") === "Admin") &&
              !location.pathname.includes('/admin') &&
              !location.pathname.includes('/user/list') &&
              !props.hideSearch && (
                <td style={{ padding: 0, textAlign: "right", verticalAlign: "top" }}>
                  <MediaSearch currentPath={props.currentPath} />
                </td>
              )}

          </tr>

          {/* Banner row directly below search */}
          {(liveUrlSet === 1 ||
            genericSuccessMessages?.message ||
            mediaServerURLs?.error_message ||
            deletedFilesInfo?.message) && (
              <tr>
                <td colSpan={100} style={{ textAlign: "right", paddingTop: 4 }}>
                  <div
                    className="confirmation"
                    style={{
                      marginLeft: "auto",      
                      marginRight: "16px",     
                      padding: "8px 12px",     
                      maxWidth: "520px",
                      background: "#fff",      
                      textAlign: "left",
                      borderRadius: "4px"
                    }}
                  >
                    {/* Example: renamed file message */}
                    {genericSuccessMessages?.message && parse(genericSuccessMessages?.message)}
                    {mediaServerURLs?.error_message && parse(mediaServerURLs?.error_message)}
                    {deletedFilesInfo?.message && parse(deletedFilesInfo?.message)}

                    {liveUrlSet === 1 && (
                      <>
                        <strong>{mediaServerFileName}&nbsp;</strong> has been pushed to
                        the live server.
                        <br />
                        <strong>
                          The live URL for this file{" "}
                          {curriculumUrl !== undefined && (
                            <>
                              <span style={{ color: "red" }}>SMS</span> or providing{" "}
                            </>
                          )}
                          {curriculumUrl !== undefined && (
                            <span style={{ color: "red" }}>open access,&nbsp;</span>
                          )}
                          is:
                        </strong>
                        <br />
                        <a href={mediaServerUrl} target="_blank" rel="noreferrer">
                          {mediaServerUrl}
                        </a>
                        {curriculumUrl !== undefined && (
                          <>
                            <br />
                            <strong>
                              The live URL when using{" "}
                              <span style={{ color: "red" }}>RUMBA</span> is:
                            </strong>
                            <br />
                            <a href={curriculumUrl} target="_blank" rel="noreferrer">
                              {curriculumUrl}
                            </a>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </td>
              </tr>
            )}
        </tbody>
      </table>
      <span className="spacer"><br /></span>

      <table border="0" width="99%" cellSpacing="0" cellPadding="0">
        <tr>
          <td className="info-box">
            <span>{bannerMessage} </span>&nbsp;
          </td>
        </tr><br></br>
        
        <tr align="left">
          <td className="info-box">
            <span>{phpbannerMessage} </span>&nbsp;
          </td>
        </tr><br></br>
        <tr align="left" valign="top" key="crumBox">
          <td align="left" valign="middle" className="crumBox"><strong>Current Location:</strong>
            {directoriesLink}
          </td>
        </tr>
      </table>
      <div className="App">
        {modal && <Modal
          displayModal={modal}
          //closeModal={selectModal}
          currentDir={props.currentPath}
          onModalPopupStateChange={handleModalPopupStateChange}
          controller={controller}
        ><Outlet /></Modal>
        }
      </div>

      <div>
        {bulkModal && <BulkUploadPopup
          displayModal={bulkModal}
          closeModal={toggleUploadPopup}
          currentDir={props.currentPath}
          onModalPopupStateChange={handleModalBulkUploadPopupStateChange}
          controller={controller}
        ><Outlet /></BulkUploadPopup>
        }
      </div>
      <div>
        {bulkdownload && <BulkDownloadPopup
          displayModal={bulkdownload}
          closeModal={toggleDownloadPopup}
          currentDir={props.currentPath}
          onModalPopupStateChange={handleModalBulkDownloadPopupStateChange}
          controller={controller}
        ><Outlet /></BulkDownloadPopup>
        }
      </div>

      <div>

        {newFolderName &&
          <ReactModal
            isOpen={newFolderName}
            onRequestClose={closeCreateFolderModalPopup}
            contentLabel="Create New Folder"
            ariaHideApp={false}
            style={customStyles}
            shouldCloseOnOverlayClick={false}
          >
            <NewFolder
              isOpen={newFolderName}
              onRequestClose={closeCreateFolderModalPopup}
              currentPath={props.currentPath}
            />
            <Outlet />
          </ReactModal>
        }
      </div>

      <div>
        {bulkrename && <BulkRenamePopup
          displayModal={bulkrename}
          closeModal={toggleRenamePopup}
          currentDir={props.currentPath}
          onModalPopupStateChange={handleModalBulkRenamePopupStateChange}
          controller={controller}
        ><Outlet /></BulkRenamePopup>
        }
      </div>


    </div>
  );
}

export default Banner;